<script setup lang="ts">
import { onMounted } from 'vue'
import { currentLocationStorage } from './elements/store'
import { isFormValidWithoutCountryCode } from './elements/address'
import { currentLocation, openCourierModal, SelectCourierModal } from './elements'

import ActiveLocation from './components/Active.vue'

async function openModal(event: Event) {
  event.preventDefault()

  if (currentLocation.value) {
    document.getElementById(currentLocation.value.id)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
  }

  openCourierModal()
}

onMounted(currentLocationStorage)
</script>

<template>
  <div>
    <template v-if="isFormValidWithoutCountryCode">
      <button class="__button" @click.prevent="openModal">
        {{ currentLocation ? 'Pas pickup-point aan' : 'Kies pickup-point' }}
      </button>
      <SelectCourierModal />
      <ActiveLocation v-if="currentLocation" :location="currentLocation" />
    </template>
    <template v-else>
      <p class="__empty">Geen address ingevuld, of adres niet beschikbaar.</p>
    </template>
  </div>
</template>
